'use client';

import React from 'react';
import { isMobile } from 'react-device-detect';
import { AreaInformation } from '~/types/areas';

type AreaDescriptionProps = {
  area_information: AreaInformation;
};

export const AreaDescription: React.FC<AreaDescriptionProps> = ({
  area_information,
}) => {
  const { title, description } = area_information;
  if (!description) return null;

  return (
    <div className="u-pl10 u-pr10">
      <div className="c-panel">
        <h2 className={`c-panel__header ${isMobile ? 'u-fs14' : ''}`}>
          {title}
        </h2>
        <div className="c-panel__body">
          <div className="p-job-search__feature">
            <div className="p-job-search__feature__content">
              <div dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AreaDescription;
